<template>
  <main class="page pto">
    <AppBack />

    <AppPageHeader title="Создать деф. ведомость"/>

    <section class="section page__content">
      <FormPtoProjectStatement
        is-edit
        :is-sending="isSendingRequest"
        @request="createPtoProjectHandler"
        @cancel="$router.back()"
      />
    </section>
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack.vue'
import AppPageHeader from '@/components/page/AppPageHeader'
import FormPtoProjectStatement from '@/components/pto/form/FormPtoProjectStatement'

import { mapActions } from 'vuex'
import { mixinPTOPageCreateProject } from '@/mixins/module/pto/project/mixinPTOPageCreateProject'

export default {
  name: 'PtoProjectStatementCreate',
  components: {
    AppPageHeader,
    AppBack,
    FormPtoProjectStatement
  },
  mixins: [
    mixinPTOPageCreateProject
  ],
  data: () => ({
    routeNameDetailed: 'PtoProjectStatementUpdate',
    postDataHasFiles: true
  }),
  async mounted () {
    await Promise.all([
      this.GETProjectPTOJobList({ projectId: this.$route.params.projectId }),
      this.GETStatementTypeList()
    ])
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETStatementTypeList: 'GETStatementTypeList',
      GETProjectPTOJobList: 'GETProjectPTOJobList'
    }),
    ...mapActions('pto/project/statement', {
      createItemAndPostFiles: 'createItemAndPostFiles'
    })
  }
}
</script>
